import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { LogCallbackDTO } from 'src/app/models/LogCallbackDTO.model';
import { InventoryService } from 'src/app/services/inventory.service';

import { TableControlComponent } from '../../controls/table-control/table-control.component';
declare var bootstrap: any;

@Component({
    selector: 'app-device-api-logs',
    templateUrl: './device-api-logs.component.html',
    styleUrl: './device-api-logs.component.css',
    imports: [TableControlComponent]
})
export class DeviceApiLogsComponent {
  @Input() device: DeviceDTO = {};
  @Input() showModal: boolean = false;
  @Input() filter: string = '';
  @Output() onDismiss = new EventEmitter<boolean>();

  logsCallback: LogCallbackDTO[] = [] as LogCallbackDTO[];
  columns = [
    { key: 'requestId', header: 'Request ID' },
    { key: 'requestNameMethod', header: 'Request Name Method' },
    { key: 'statusCode', header: 'Status' },
    { key: 'faultCode', header: 'Fault Code' },
    { key: 'faultString', header: 'Fault' },
    { key: 'dateCreatedString', header: 'Date Created' }
  ];

  constructor(private inventoryService: InventoryService) {


  }

  ngOnInit() {

  }

  ngOnChanges() {
    if (this.showModal) {
      this.inventoryService.getLogsCalback(this.device).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleGetLogs(Data);
          } else {

          }
        },
        (error) => {

        }
      );
    }
  }

  ondDismissModal() {
    this.onDismiss.emit(false);
  }

  HandleGetLogs(logs: LogCallbackDTO[]) {

    if(this.filter) {
      logs = logs.filter(log => log.requestNameMethod?.toLowerCase().includes(this.filter.toLowerCase()));
    }
    
    this.logsCallback = logs;
        
    const modalDeviceApiLogs = new bootstrap.Modal("#modalDeviceApiLogs");
    modalDeviceApiLogs.show();
  }
}
